// @flow
export const HEFTY_ROLE = 'Hefty'
